'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = debounce;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

function debounce(fn) {
  var args = undefined;
  var next = undefined;
  function loop() {
    next = _raf2['default'](function () {
      next = null;
      fn.apply(undefined, _toConsumableArray(args));
    });
  }
  return {
    fn: function fn() {
      for (var _len = arguments.length, argv = Array(_len), _key = 0; _key < _len; _key++) {
        argv[_key] = arguments[_key];
      }

      if (!next) loop();
      args = argv;
    },
    cancel: function cancel() {
      if (next) _raf2['default'].cancel(next);
    }
  };
}

module.exports = exports['default'];

